import React, { useState } from "react";
import { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";

import { TemplateOfferingConfirmOrderDayOffice } from "../template_offering_confirm_order_day_office";
import { useWeWorkAnalytics } from "./wework_analytics";
import { useWeWorkPartnerConfig } from "./wework_partner_config";
import { PostPurchaseModal } from "./post-purchase/post_purchase_modal";

const Theme = lazyWithRetry(() => import("./wework_theme"));

export function OfferingWeWorkConfirmOrderDayOffice() {
  useWeWorkAnalytics();
  const partnerConfig = useWeWorkPartnerConfig();

  const [isPostPurchaseModalOpen, setIsPostPurchaseModalOpen] = useState(true);
  return (
    <Fragment>
      <Theme />
      <TemplateOfferingConfirmOrderDayOffice partnerConfig={partnerConfig} />
      <PostPurchaseModal
        isOpen={isPostPurchaseModalOpen}
        onRequestClose={() => setIsPostPurchaseModalOpen(false)}
      />
    </Fragment>
  );
}
